import AUTH_CODES from './auth-codes';
import ACCOUNT_CODES from './account-codes';
import TERMINAL_CODES from './terminal-codes';
import COMPANY_CODES from './company-codes';
import DOCUMENT_CODES from './document-codes';
import WEBSITE_CODES from './website-codes';
import { GENERAL_CODES } from './general';
import { PRODUCT_CODES } from './product-codes';
import { PRODUCT_CATEGORY_CODES } from './product-categories-codes';
import { NESTED_PRODUCT_CODES } from './nested-product-codes';
import { NESTED_PRODUCT_CATEGORY_CODES } from './nested-product-categories-codes';
import { PROMOTION_CODES } from './promotion-codes';
import { COMPANY_OWNER_CODES } from './company-owner-codes';
import PLACE_CODES from './place-codes';

export const ERROR_CODES = {
    auth: AUTH_CODES,
    accounts: ACCOUNT_CODES,
    terminal: TERMINAL_CODES,
    company: COMPANY_CODES,
    document: DOCUMENT_CODES,
    website: WEBSITE_CODES,
    general: GENERAL_CODES,
    place: PLACE_CODES,
    products: PRODUCT_CODES,
    productCategories: PRODUCT_CATEGORY_CODES,
    nestedProducts: NESTED_PRODUCT_CODES,
    nestedProductCategories: NESTED_PRODUCT_CATEGORY_CODES,
    promotion: PROMOTION_CODES,
    companyOwner: COMPANY_OWNER_CODES,

    // General error codes
    AUTH_ACCOUNT_NOT_ASSIGNED_TO_TERMINAL: 'A010',
    AUTH_PLACE_NOT_ASSIGNED_TO_TERMINAL: 'A011',
    AUTH_ROLE_NOT_AUTHORIZED: 'A015',
};
